import NotificationTemplateDetail from './NotificationTemplateDetail';

export default NotificationTemplateDetail;
